/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { resendConfirmationCodePostRequestSchema } from './resendConfirmationCodePostRequestSchema.ts';
import { resendConfirmationCodePostResponseSchema } from './resendConfirmationCodePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postResendConfirmationCode200Schema = z.lazy(() => resendConfirmationCodePostResponseSchema);

/**
 * @description 505 response
 */
export const postResendConfirmationCode505Schema = z.any();

export const postResendConfirmationCodeMutationRequestSchema = z.lazy(() => resendConfirmationCodePostRequestSchema);

export const postResendConfirmationCodeMutationResponseSchema = z.lazy(() => postResendConfirmationCode200Schema);
